module.exports = __webpack_public_path__ + "img/icon_volume_o.2971087d.svg";